import { IconBell, IconPlus, IconX } from "@tabler/icons-react";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { whatsappPopupDismissedUpdate } from "../services/store";
import Loading from "./Loading";
import { toast } from "react-toastify";
import moment from "moment";

const AutomaticMessageAlertDialog = ({ onClose, open, refetch }: any) => {
  const { mutate, isPending } = useMutation({
    mutationFn: whatsappPopupDismissedUpdate,
    onSuccess: () => {
      toast.success("Dados atualizado");
      refetch();
      onClose();
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
      onClose();
    },
  });

  return (
    <Dialog maxWidth="xs" fullWidth open={open}>
      <Loading loading={isPending} />
      <DialogTitle>
        <Stack>
          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            Ativar serviço de mensageria?
            <Stack>
              <IconButton
                onClick={() =>
                  mutate({
                    whatsappPopupUpdatedAt: moment().add(1, "day").toDate(),
                  })
                }
              >
                <IconX />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2}>
          <Grid2 size={12} mb={2}>
            <Typography
              lineHeight={1.5}
              variant="body1"
              color="secondary.contrastText"
            >
              Você gostaria de ativar os serviços de mensageria via WhatsApp do
              FightGo? <br />
              Caso queira, basta clicar no botão <strong>Ativar agora</strong> e
              iremos te levar até a área de configuração.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              color="success"
              variant="contained"
              sx={{
                gap: 0.5,
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() =>
                mutate({ whatsappPopupDismissed: 1, autoNotificationWpp: 1 })
              }
            >
              <Typography variant="body2">Ativar agora</Typography>
              <IconPlus size={18} />
            </Button>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                backgroundColor: "secondary.dark",
                gap: 0.5,
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() =>
                mutate({
                  whatsappPopupUpdatedAt: moment().add(1, "day").toDate(),
                })
              }
            >
              <Typography variant="body2">Me lembrar depois</Typography>
              <IconBell size={18} />
            </Button>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                gap: 0.5,
                justifyContent: "space-between",
                alignItems: "center",
              }}
              color="error"
              onClick={() =>
                mutate({ whatsappPopupDismissed: 1, autoNotificationWpp: 0 })
              }
            >
              <Typography variant="body2">Não quero mais receber</Typography>
              <IconX size={18} />
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default AutomaticMessageAlertDialog;
